import {createTableState, normalizePagination} from '@/core/services/Helper'
import router from "@/router";

const state = () => ({
    selectCompany: null,
    table: createTableState(),
    filterData: undefined
})

// getters
const getters = {
    selectCompany(state) {
        return state.selectCompany;
    }
}

// actions
const actions = {
    // get records
    async get({state, commit, dispatch}, {filterData}) {
        commit('setLoading', true)

        state.filterData = filterData;

        let params = {};

        if (state.filterData) {
            params = {...params, ...state.filterData};
        }

        const res = await this._vm.axios.get(this._vm.endpoints['authorized'], {
            params: params
        })

        const {data} = res.data
        commit('updateTableData', data)

        if (!state.selectCompany) {
            const defaultCompanyId = data[0].id
            dispatch('setSelectCompany', defaultCompanyId)
        }

        setTimeout(() => {
            commit('setLoading', false)
        }, 250)
    },

    // refresh records
    refresh({dispatch}) {
        dispatch('get');
    },

    setSelectCompany({commit}, companyId) {
        commit('setSelectCompany', companyId)
        this._vm.eventBus.$emit('setSelectCompany');

        if (companyId) {
            localStorage.setItem('selected_company', companyId);
            this._vm.$store.dispatch('company/module/refresh');
        } else {
            localStorage.removeItem('selected_company')
        }

        router.push({
            path: "/dashboard",
        });
    },

    initSelectCompany({commit}) {
        const stored = localStorage.getItem('selected_company')
        if (stored) {
            commit('setSelectCompany', Number(stored))
        }
    }

}

// mutations
const mutations = {
    setLoading(state, val) {
        state.table.loading = val
    },
    updateTableData(state, data) {
        state.table.data = data
    },
    setSelectCompany(state, company) {
        state.selectCompany = company
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}